<template>
  <el-drawer
    title="详情"
    append-to-body
    :close-on-press-escape="false"
    :visible.sync="show"
    size="35%"
    direction="rtl">
    <div
      v-loading="loading"
      class="detail-drawer-wrap">
      <el-form label-width="85px">
        <el-form-item label="资讯模式："> {{ ruleForm.contentType | ContentModeName() }}</el-form-item>
        <el-form-item label="资讯标题：">{{ ruleForm.title }}</el-form-item>
        <el-form-item label="资讯来源："> {{ ruleForm.source }}</el-form-item>
        <el-form-item label="发布时间：">{{ ruleForm.createdTime | dateformat('YYYY-MM-DD') }}</el-form-item>
        <el-form-item label="资讯分组：">{{ ruleForm.topicName }}</el-form-item>
        <el-form-item label="资讯首图：">
          <image-list
            :list="ruleForm.image"
            :listType="3" />
        </el-form-item>
        <el-form-item label="上架状态：">{{ ruleForm.status === 1 ? '已上架' : '未上架' }}</el-form-item>
        <el-form-item label="排序值：">{{ ruleForm.sort }}</el-form-item>
        <el-form-item label="资讯详情：">
          <desc-images
            v-if="ruleForm.contentType === 0"
            v-model="ruleForm.content1"></desc-images>
          <span
            v-if="ruleForm.contentType === 1"
            style="word-break: break-all;">
            <el-link
              type="primary"
              :underline="false"
              :href="ruleForm.content"
              target="_blank">{{ ruleForm.content }}</el-link>
          </span>
        </el-form-item>
      </el-form>
    </div>
  </el-drawer>
</template>
<script>
import ImageList from '@/components/image-list.vue'
import DescImages from '@/components/public/desc-images.vue'
import Common from '@/service/common'
export default {
  name: 'DetailDrawer',
  components: { ImageList, DescImages },
  data() {
    return { show: false, loading: false, config: { id: null }, ruleForm: { image: '', content1: [] }}
  },
  methods: {
    fetchInfo() {
      this.loading = true
      Common.getinfo({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, contentType, content } = res.data
          if (result === 0) {
            this.$set(this, 'ruleForm', {
              ...res.data,
              content1: contentType === 0 ? this.$splitImage(content) : [],
              content: contentType === 1 ? content : ''
            })
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch(options = {}) {
      this.config = { ...this.config, ...options }
      this.show = true
      this.fetchInfo()
    }
  }
}
</script>
